import React from 'react';
import ProjectDetail from './ProjectDetail';
import { motion } from 'framer-motion';
import { projectMeta } from './data';
import { HugeiconsIcon } from '@hugeicons/react';
import { NewTwitterIcon, Linkedin01Icon, Mail01Icon, InstagramIcon } from '@hugeicons-pro/core-stroke-sharp';
import Button from '../components/Button';


export default function About() {
  const meta = projectMeta.about;
  return (
    <ProjectDetail title={meta.title} date={meta.date} role={meta.role}>

      <div className="about-photos">
        <motion.img
          src="./images/about/surf.webp"
          initial={{ x: 150, y: 0, scale: 0.75, rotate: 0, opacity: 0 }} // Initial position and scale
          animate={{ x: 0, y: 10, scale: 1, rotate: -10, opacity: 1 }} // Move left and scale up
          transition={{ type: "spring", stiffness: 100, delay: 0.2 }}
        />
        <motion.img
          src="./images/about/maine.webp"
          initial={{ x: 150, y: 0, scale: 0.75, rotate: 0, opacity: 0 }} // Initial position and scale
          animate={{ x: 290, y: 10, scale: 1, rotate: 8, opacity: 1 }} // Move left and scale up
          transition={{ type: "spring", stiffness: 100, delay: 0.3 }}
        />
        <motion.img
          src="./images/about/office.webp"
          initial={{x: 150, y: 0, scale: 0.75, rotate: 0, opacity: 0 }} // Initial position and scale
          animate={{x: 150, y: -15, scale: 1, rotate: 2, opacity: 1 }} // Move left and scale up
          transition={{ type: "spring", stiffness: 100, delay: 0.1 }}
        />
      </div>

      <h1 className="about-title">Hi, I'm Todd</h1>

      <p>I’m a product designer and developer with over 20 years of experience turning ideas into real products. I’ve designed for billions of users at Meta, where I spent a decade shaping design systems and product experiences across the company.</p>

      <p>Today, I’m building <a href="https://www.aiproxy.com" target="_blank" rel="noopener noreferrer">AIProxy</a>, a backend security tool that helps app developers safely integrate AI into their products. AIProxy safely powers millions of AI requests per month and is used by thousands of apps.</p>

      <p>I love prototyping, mentoring other designers, and exploring the intersection of design, code, and AI. When I’m not in front of a screen, you’ll find me surfing, golfing, or hanging out with my family.</p>

      <h3>Experience</h3>
      <div className="experience-section">
        <div className="experience-list">
          <div className="experience-item">
            <div className="experience-left">
              <div className="experience-company">AIProxy</div>
              <div className="experience-role">Cofounder</div>
            </div>
            <div className="experience-right">
              <div className="experience-dates">2024—Present</div>
            </div>
          </div>

          <div className="experience-item">
            <div className="experience-left">
              <div className="experience-company">Facebook Studio</div>
              <div className="experience-role">Design architect</div>
            </div>
            <div className="experience-right">
              <div className="experience-dates">2020—2024</div>
            </div>
          </div>

          <div className="experience-item">
            <div className="experience-left">
              <div className="experience-company">Facebook Marketplace</div>
              <div className="experience-role">Lead product designer</div>
            </div>
            <div className="experience-right">
              <div className="experience-dates">2017—2022</div>
            </div>
          </div>

          <div className="experience-item">
            <div className="experience-left">
              <div className="experience-company">Facebook Developer Tools</div>
              <div className="experience-role">Lead product designer</div>
            </div>
            <div className="experience-right">
              <div className="experience-dates">2014—2016</div>
            </div>
          </div>

          <div className="experience-item">
            <div className="experience-left">
              <div className="experience-company">Joypad</div>
              <div className="experience-role">Cofounder</div>
            </div>
            <div className="experience-right">
              <div className="experience-dates">2011—2013</div>
            </div>
          </div>
        </div>
      </div>


      <h3>Contact</h3>
      <div className="contact-buttons">
        <Button
          square
          href="https://twitter.com/toddham"
          target="_blank"
          rel="noopener noreferrer"
          ariaLabel="Twitter"
          leading={<HugeiconsIcon icon={NewTwitterIcon} size={24} strokeWidth={1.5} color="currentColor" />}
        />
        <Button
          square
          ariaLabel="Instagram"
          title="Instagram"
          leading={<HugeiconsIcon icon={InstagramIcon} size={24} strokeWidth={1.5} color="currentColor" />}
        />
        <Button
          square
          ariaLabel="LinkedIn"
          title="LinkedIn"
          leading={<HugeiconsIcon icon={Linkedin01Icon} size={24} strokeWidth={1.5} color="currentColor" />}
        />
        <Button
          square
          href="mailto:toddham@gmail.com"
          ariaLabel="Email"
          leading={<HugeiconsIcon icon={Mail01Icon} size={24} strokeWidth={1.5} color="currentColor" />}
        />
      </div>

    </ProjectDetail>
  );
}


